import AppRoutes from './routes/Routes';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, logPageView } from './lib/ga'; // Adjust path if needed

function App() {
  const location = useLocation();

  useEffect(() => {
    initGA();
    logPageView(location.pathname);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    logPageView(location.pathname);
  }, [location.pathname]);

  return (
    <AppRoutes />
  );
}

export default App;
